/**
 * Identity — Real Codiaj brand data pulled from content-source/real-content.json.
 * This is the single source of truth for legal name, contact data, and address.
 * Use this everywhere instead of hard-coding phones, emails, or addresses.
 */

export interface Identity {
  nombre: string;
  direccion: string;
  telefonos: string[];
  email: string;
  ubicacion: string;
  redes: { label: string; href: string }[];
  lema: string;
}

export const identity: Identity = {
  nombre: "Codiaj",
  direccion: "C/ Pablo Gargalo 35, 28035 Madrid",
  telefonos: [
    "+34 635 715 157", 
    "+34 635 058 315"
  ],
  email: "info@codiaj.es",
  ubicacion: "Madrid, España",
  redes: [
    { label: "WhatsApp", href: "https://wa.me/34635715157" },
    { label: "Instagram", href: "https://instagram.com/codiaj" },
    { label: "TikTok", href: "https://tiktok.com/@codiaj" },
    { label: "YouTube", href: "https://youtube.com/@codiaj" },
  ],
  lema: "Diseño web profesional sin pago inicial. Pagas solo cuando te encanta.",
};

/** Helper: convert a phone like "+34 635 715 157 (Label)" to a tel: href. */
export function telHref(phone: string): string {
  const clean = phone.split("(")[0].replace(/[^\d+]/g, "");
  return `tel:${clean}`;
}

/** Helper: convert a phone to a wa.me href. */
export function waHref(phone: string): string {
  const clean = phone.split("(")[0].replace(/[^\d]/g, "");
  return `https://wa.me/${clean}`;
}
